import {Component, Object3D, PhysXComponent} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {WeaponComponent} from './weapon-component.js';
import {WeaponPrefabs} from './weapon-prefabs.js';
import {gameState} from '../state/GameState.js';
import {Weapon} from '../state/combat/Weapon.js';

export class ShopComponent extends Component {
    static TypeName = 'shop-component';

    /**
     * Comma separated list of weapons that are available in the shop.
     * These should correspond with the names of the objects in Weapons.wlp and weaponsPrefabs
     */
    @property.string('Axe')
    shopItems = 'Axe';

    @property.string('Merchant')
    merchantName = 'Merchant';

    private _shopItems: WeaponComponent[] = [];
    private _physxComponent!: PhysXComponent;

    start(): void {
        this._physxComponent = this.object.getComponent(PhysXComponent)!;
        this._physxComponent;
        WeaponPrefabs.instance.onPrefabsLoaded.add(() => {
            const weapons = WeaponPrefabs.instance.weaponPrefabs.children.filter((c) =>
                this.shopItems.split(/\s*,\s*/).includes(c.name)
            );
            this._shopItems = weapons.map((w) => w.getComponent(WeaponComponent)!);
        });
    }

    enterShop() {
        const items = this._shopItems.map(
            (w) => new Weapon(w.specialName, w.baseDamage, w.price, w.object.name)
        );
        gameState.enterShop(this.merchantName, items);
    }
}
